import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import Pagination from "../elements/common/Pagination";
import NewsList from "../elements/news/NewsList";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import { useTranslation } from "react-i18next";

const News = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  return (
    <React.Fragment>

      <Header
        headertransparent="header--transparent"
        colorblack="color--black"
        logoname="logo.png"
      />

      <Breadcrumb
        title={isEnglish ? "Collaboration et partenariats" : "Collaboration and Partnership	"}
      />
     
      <div className="rn-news-area ptb--120 bg_color--1">
        <div className="container">
          <NewsList />
          
        </div>
      </div>

      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>

      <Footer />
    </React.Fragment>
  );
};
export default News;
